import { Controller } from "stimulus"

export default class extends Controller {
  submit(_event) {
    this.element.requestSubmit();
  }
}
